import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { AdminPermissions } from 'app/library/feature/enums/admin-permissions.enum';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { Observable, of } from 'rxjs';

@Injectable()
export class AdminCertificationWriteGuard  {
    user = this._store.selectSnapshot(UserState.getMyInfo);

    get hasTenantAdminOrPerformanceReviewWriteReadPermission(): boolean {
        return this.user.permissions.includes(AdminPermissions.CERTIFICATION_WRITE) || this.user.permissions.includes(AdminPermissions.TENANT_MANAGEMENT);
    }

    constructor(private _store: Store, private _router: Router) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.hasTenantAdminOrPerformanceReviewWriteReadPermission) {
            return of(true);
        } else {
            this._router.navigateByUrl(`${'/admin'}`);
            return of(false);
        }
    }
}
